import { render, staticRenderFns } from "./speltselec.vue?vue&type=template&id=03433606&scoped=true&"
import script from "./speltselec.vue?vue&type=script&lang=js&"
export * from "./speltselec.vue?vue&type=script&lang=js&"
import style0 from "./speltselec.vue?vue&type=style&index=0&id=03433606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03433606",
  null
  
)

export default component.exports